<script>
import options from './StafetDeltagPaaHoldStepYourInformation.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-join-a-team-step-your-information kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.yourInformationTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">

      <FormCheckbox
        v-if="isFighter"
        fieldName="firstTimeFighter"
        :modelValue="firstTimeFighter.toString()"
        v-model="firstTimeFighter"
        :label="labels.yourInformationFirstTimeFighterBoolLabel"
        :onChangeCallback="(e) => setFirstTimeFighter(e.target.checked)"
      />

      <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
        <FormInputTextField
          fieldName="firstName"
          :modelValue="firstName"
          v-model="firstName"
          :label="labels.yourInformationFirstNameLabel"
          :isRequired="true"
          :readOnly="readOnly.firstName"
          :isValidationError="showFirstNameErrorMessage"
          :errorMessageLabel="labels.yourInformationFirstNameErrorMessage"
          :onChangeCallback="(e) => validateField('firstName', e.target.value)"
        />

        <FormInputTextField
          fieldName="lastName"
          :modelValue="lastName"
          v-model="lastName"
          :label="labels.yourInformationLastNameLabel"
          :isRequired="true"
          :readOnly="readOnly.lastName"
          :isValidationError="showLastNameErrorMessage"
          :errorMessageLabel="labels.yourInformationLastNameErrorMessage"
          :onChangeCallback="(e) => validateField('lastName', e.target.value)"
        />
      </div>

      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          fieldName="email"
          :modelValue="email"
          v-model="email"
          :label="labels.yourInformationEmailLabel"
          :isRequired="true"
          :readOnly="readOnly.email"
          :isValidationError="showEmailErrorMessage"
          :errorMessageLabel="labels.yourInformationEmailErrorMessage"
          :onChangeCallback="(e) => validateField('email', e.target.value)"
        />

        <FormInputTextField
          fieldName="phone"
          :modelValue="phone"
          v-model="phone"
          :readOnly="readOnly.phone"
          :isValidationError="showPhoneErrorMessage"
          :label="labels.yourInformationPhoneNumberLabel"
          :errorMessageLabel="labels.yourInformationPhoneNumberErrorMessage"
          :onChangeCallback="(e) => validateField('phone', e.target.value)"
        />
      </div>
    </div>
    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        fieldName="consent"
        :modelValue="consent.toString()"
        v-model="consent"
        :label="labels.yourInformationConsentBoolLabel"
        :isRichText="true"
        :isRequired="true"
        :isValidationError="showConsentErrorMessage"
        :errorMessageLabel="labels.yourInformationConsentBoolErrorMessage"
        :onChangeCallback="(e) => setConsent(e.target.checked)"
      />
  
      <FormCheckbox
        fieldName="newsletter"
        :modelValue="newsletter.toString()"
        v-model="newsletter"
        :label="labels.yourInformationNewsLetterBoolLabel"
        :onChangeCallback="(e) => validateField('newsletter', e.target.checked)"
      />

      <FormCheckbox
        v-if="isFighter"
        fieldName="fighterNewsletter"
        :modelValue="fighterNewsletter.toString()"
        v-model="fighterNewsletter"
        :label="labels.yourInformationFighterNewsletterBoolLabel"
        :onChangeCallback="(e) => validateField('fighterNewsletter', e.target.checked)"
      />
    </div>

    <a v-if="loggedIn" :href="redirectToEditProfile" class="kb-link">{{
      editProfileLinkText
    }}</a>

    <StafetPayment
      :title="labels.yourInformationTotalYourDeltagergebyrLabel"
      :basket="basket"
      :inTotalLabel="labels.yourInformationTotal"
      :inTotalPrice="basketTotalPrice.toString()"
    />

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep4"
      :previousStepCallback="previousStepCallback"
      :previousStepLabel="labels.formNavigationPrevStep"
    />
  </article>
</template>
